//Api Resources: cada recurso representa um microserviço do PreBilling
export const resources = {
    bonificacao: "Bonificacao",
    cicloFaturamento: "CicloFaturamento",
    cliente: "Cliente",
    clienteInstalacao: "ClienteInstalacao",
    concessionaria: "Concessionaria",
    configuracaoAlarme: "ConfiguracaoAlarme",
    faturaConcessionaria: "FaturaConcessionaria",
    faturaInstalacao: "FaturaInstalacao",
    faturaUsina: "FaturaUsina",
    faturaCliente: "FaturaCliente",
    faturaPrevista: "FaturaPrevista",
    faturaSaldoChurn: "FaturaSaldoChurn",
    grupoAlarme: "GrupoAlarme",
    historicoSaldoInstalacao: "HistoricoSaldoInstalacao",
    instalacao: "Instalacao",
    lancamentoManual: "LancamentoManual",
    modeloFatura: "ModeloFatura",
    motivoLancamentoManual: "MotivoLancamentoManual",
    parceiro: "Parceiro",
    parametro: "Parametrizacao",
    rebalanceMotivoMovimentacaoInstalacao: "RebalanceMotivoMovimentacao",
    relatorio: "Relatorio",
    revisaoCotaUsina: "RevisaoCotaUsina",
    revisaoCotaInstalacao: "RevisaoCotaInstalacao",
    saldoInstalacao: "SaldoInstalacao",
    sensediaAccessToken: "/access-token",
    sincronizacao: "Sincronizacao",
    usina: "Usina",
    usuario: "Usuario",
    parametrizacaoRebate: "ParametrizacaoRebate",
    rebalanceUsinaHistoricoGeracao: "RebalanceUsinaHistoricoGeracao",
    rebalanceMovimentacaoInstalacao: "RebalanceMovimentacaoInstalacao",
    rebalanceUsinaInstalacao: "RebalanceUsinaInstalacao",
    rebalanceUsina: "RebalanceUsina",
    rebateUsina: "rebateusina",
    rebateUsinaInstalacao: "rebateusinainstalacao",
    relatorioWhiteLabel: "relatoriowhitelabel",
    campanhaComercial: "CampanhaComercial",
    marcador: "Marcador",
};
